import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "low_base.sprite",
  "use": "low_base.sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"low_base.sprite\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6 4.9C6 3.85066 6.85066 3 7.9 3H23.1C24.1493 3 25 3.85066 25 4.9V27.1C25 27.4708 24.8938 27.8168 24.7101 28.1092C24.374 28.6443 23.7785 29 23.1 29H7.9C6.85066 29 6 28.1493 6 27.1V4.9ZM8 17.8571C8 17.8571 8 6.5 8 6C8 5.5 8.5 5 9 5C9.5 5 21.5 5 22 5C22.5 5 23 5.5 23 6C23 6.5 23 17.8571 23 17.8571H8Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol